import { render, staticRenderFns } from "./main-cost-table.vue?vue&type=template&id=6aba5960&scoped=true"
import script from "./main-cost-table.vue?vue&type=script&lang=js"
export * from "./main-cost-table.vue?vue&type=script&lang=js"
import style0 from "./main-cost-table.vue?vue&type=style&index=0&id=6aba5960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aba5960",
  null
  
)

export default component.exports